// TODO: move inside app/
import React from 'react';

// context
import { AuthProvider } from 'context/hooks/useAuth';
import { AppStateProvider } from 'context/hooks/useAppState'
import { WorkflowProvider } from 'context/hooks/useWorkflowTracker';
import { CubeProvider } from 'context/hooks/useCube'
import { ReactFlowProvider } from 'reactflow';
import { WorkflowBuilderProvider } from './hooks/useWorkflowBuilder';

const AppContextProviders = ({
  children
}) => {
  return (
    <AppStateProvider>
      <AuthProvider>
          <WorkflowProvider>
            <CubeProvider>
              <ReactFlowProvider>
                <WorkflowBuilderProvider>
                  {children}
                </WorkflowBuilderProvider>
              </ReactFlowProvider>
            </CubeProvider>
          </WorkflowProvider>
      </AuthProvider>
    </AppStateProvider>
  );
};

export default AppContextProviders;